// eslint-disable-next-line no-undef
module.exports = {
  headers: {
    accept: 'application/json'
  },
  //baseUrl: 'http://localhost:44303/api/'
  baseUrl: 'https://app.rotoronline.com.br/api/'
}
